export const ANALYTICS_CREATE = 'ANALYTICS_CREATE';
export const ANALYTICS_METRICS_REQUEST = 'ANALYTICS_METRICS_REQUEST';
export const ANALYTICS_METRICS_SUCCESS = 'ANALYTICS_METRICS_SUCCESS';
export const ANALYTICS_METRICS_FAILURE = 'ANALYTICS_METRICS_FAILURE';
export function createAnalytics(instance) {
  const implementation = {
    siteId: instance.siteId,
    apiKey: instance.apiKey,
    apiEndpoint: instance.apiEndpoint,
    isPublic: instance.isPublic,
    getMetrics: instance.getMetrics || (() => undefined),
    parseMetrics: instance.parseMetrics || (() => undefined)
  };
  return {
    type: ANALYTICS_CREATE,
    payload: {
      implementation
    }
  };
}
export function metricsLoading(period) {
  return {
    type: ANALYTICS_METRICS_REQUEST,
    payload: {
      period
    }
  };
}
export function metricsLoaded(metrics, period, interval) {
  return {
    type: ANALYTICS_METRICS_SUCCESS,
    payload: {
      metrics,
      period,
      interval
    }
  };
}
export function metricsFailed(error) {
  return {
    type: ANALYTICS_METRICS_FAILURE,
    payload: {
      error
    }
  };
}
export function fetchMetrics(period) {
  return async (dispatch, getState) => {
    dispatch(metricsLoading(period));
    const state = getState();
    const {
      implementation
    } = state.analytics;
    try {
      const {
        metrics,
        interval
      } = await implementation.getMetrics(period);
      dispatch(metricsLoaded(metrics, period, interval));
    } catch (error) {
      dispatch(metricsFailed(error));
    }
  };
}